import React from 'react';
import Modal from 'react-modal';
import Button from '../../../../Forms/Button';

import './CancelPlanConfirm.scss';

interface ConfirmCancelPlanModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    onConfirm: () => void;
}

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        border: 'solid 1px #D72020',
        borderRadius: '16px',
        boxShadow: '3px 4px 15px rgba(170, 170, 208, 0.5)',
        transform: 'translate(-50%, -50%)',
        overflow: 'visible'
    }
};
Modal.setAppElement('#root');

function ConfirmCancelPlanModal({
    isOpen,
    onRequestClose,
    onConfirm
}: ConfirmCancelPlanModalProps) {

    return (
        <Modal
            isOpen={isOpen}
            style={customStyles}
            onRequestClose={onRequestClose}
            shouldCloseOnEsc={true}
            shouldCloseOnOverlayClick={true}
            contentLabel="Cancelar Subscripción"
        >
            <div id="cancelPlanModal">
                <h4>¡Aviso!</h4>
                <div className='iconWrapper'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
                        <circle cx="50" cy="50" r="47.5" stroke="#D72020" stroke-width="5" />
                        <path d="M47.205 62.1055H53.1271L56.166 14.2026L44.166 14.1055L47.205 62.1055Z" fill="#D72020" />
                        <path d="M46.166 69.1055V79.1055H54.166V69.1055H46.166Z" fill="#D72020" />
                    </svg>
                </div>
                <div className='contentText'>
                    <p>
                        Al cancelar el plan, <b>todas las cuentas conectadas</b> de FiscalPOP que requieran subscripción <b>serán desactivadas y no podrás generar CFDIs</b> hasta que tengas un plan activo nuevamente.
                    </p>
                    <p>
                        Si contabas con un saldo positivo previamente, este se mantendrá en tu cuenta, pero las facturas sin consumir de tu plan actual <b>no se abonarán a tu saldo</b>.
                    </p>
                    <p>
                        Estos cambios se aplicarán <b>inmediatamente al cancelar tu plan</b>, por lo que te recomendamos revisar tu cuenta y plataformas conectadas para evitar interrupciones en tu facturación.
                    </p>
                </div>
                <div className="buttonRow">
                    <Button primary handleClick={onConfirm}>
                        <span>
                            Cancelar mi plan
                        </span>

                    </Button>
                    <Button tertiary handleClick={onRequestClose}>
                        <span>
                            Salir
                        </span>
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default ConfirmCancelPlanModal;